const data = [
    {
        "id": 1, "label": "國小"
    },
    {
        "id": 2, "label": "國中"
    },
    {
        "id": 3, "label": "高中"
    },
    {
        "id": 4, "label": "大學"
    },
    {
        "id": 5, "label": "碩士"
    },
    {
        "id": 6, "label": "博士"
    },
]

export default data